export const WAVE_ANIMATION = {
  init: function () {
    const isSP = window.matchMedia('(max-width: 768px)').matches
    if (isSP) return // ← ここで完全に止める

    const waveWrap = document.querySelector('.wave-wrap')
    const wave1 = document.querySelector('#wavePath1')
    const wave2 = document.querySelector('#wavePath2')

    if (!waveWrap || !wave1 || !wave2) return
    if (typeof gsap === 'undefined') return

    // ===== wave2 パス =====
    const w2_2 =
      'M1920 24C1700 100 1500 20 1200 40C900 60 600 30 300 50C150 60 50 30 0 20V136H1920V24Z'
    const w2_3 =
      'M1920 24C1600 60 1400 120 1100 80C800 40 500 90 250 60C100 40 50 70 0 40V136H1920V24Z'

    // ===== 出現アニメ =====
    const tl = gsap.timeline()

    tl.to('.wave', {
      y: 0,
      opacity: 1,
      duration: 1.2,
      ease: 'power3.out',
      stagger: 0.2,
    })

    // ===== 波アニメ =====
    tl.add(() => {
      // --- wave1（timelineで安定化）---
      gsap
        .timeline({ repeat: -1, yoyo: true })
        .to(wave1, {
          duration: 6,
          attr: { d: 'M1920 0C1500 100 1200 160 800 60C500 0 200 60 0 120V160H1920V0Z' },
          ease: 'sine.inOut',
        })
        .to(wave1, {
          duration: 6,
          attr: { d: 'M1920 0C1400 180 1100 80 700 40C400 10 200 100 0 80V160H1920V0Z' },
          ease: 'sine.inOut',
        })

      // --- wave2 ---
      gsap
        .timeline({ repeat: -1, yoyo: true })
        .to(wave2, {
          duration: 6,
          attr: { d: w2_2 },
          ease: 'sine.inOut',
        })
        .to(wave2, {
          duration: 6,
          attr: { d: w2_3 },
          ease: 'sine.inOut',
        })

      // --- ふわふわ ---
      gsap.to('.wave1', {
        y: 10,
        duration: 4,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      })

      gsap.to('.wave2', {
        y: -4,
        duration: 8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      })
    })
  },
}
